module.exports = __webpack_public_path__ + "img/play.fc6c19f4.png";